import { render, staticRenderFns } from "./purposeHospitalization.vue?vue&type=template&id=30a453c6&"
import script from "./purposeHospitalization.vue?vue&type=script&lang=js&"
export * from "./purposeHospitalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports